import React from 'react';

export const TermsCheckbox = ({ checked, onChange, testid = 'accept-terms-checkbox', disabled }) => (
  <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      className="mt-0.5 h-4 w-4 accent-blue-600"
      data-testid={testid}
    />
    <span>
      I have read and agree to the{' '}
      <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline" data-testid={`${testid}-tos-link`}>Terms of Service</a>
      {' '}and the{' '}
      <a href="/saas-agreement" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline" data-testid={`${testid}-saas-link`}>SaaS Agreement</a>,
      including the restrictions on reverse engineering.
    </span>
  </label>
);
